import { render } from "./RecoverPasswordForm.vue?vue&type=template&id=6feb92f7&ts=true"
import script from "./RecoverPasswordForm.vue?vue&type=script&lang=ts"
export * from "./RecoverPasswordForm.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\repos\\Platform\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__